export default __webpack_public_path__ + "static/media/image_4.9c4df156.jpg";